export function createChatWorker(): Worker {
    return new Worker(new URL('./chat.worker.ts', import.meta.url));
}
